import { datadogRum } from '@datadog/browser-rum'

import { actionTypes } from 'actions/actionTypes'

const TRACKING_EVENT_NAME = 'profile_navigation_bar_click'

export const trackAccountNavBarClick = (sectionName) => (dispatch) => {
  datadogRum.addAction(TRACKING_EVENT_NAME, { sectionName })
  dispatch({
    type: actionTypes.TRACKING,
    trackingData: {
      actionType: TRACKING_EVENT_NAME,
      section: sectionName,
    },
  })
}
